import { render, staticRenderFns } from "./PatientVerificationList.vue?vue&type=template&id=68298370&scoped=true"
import script from "./PatientVerificationList.vue?vue&type=script&lang=js"
export * from "./PatientVerificationList.vue?vue&type=script&lang=js"
import style0 from "./PatientVerificationList.vue?vue&type=style&index=0&id=68298370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68298370",
  null
  
)

export default component.exports